
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"44","viewBox":"0 0 45 44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.2696 12.5401C31.9896 4.40012 21.2096 1.98012 12.8496 7.04012C4.70957 12.1001 2.06957 23.1001 7.34957 31.2401L7.78957 31.9001L6.02957 38.5001L12.6296 36.7401L13.2896 37.1801C16.1496 38.7201 19.2296 39.6001 22.3096 39.6001C25.6096 39.6001 28.9096 38.7201 31.7696 36.9601C39.9096 31.6801 42.3296 20.9001 37.2696 12.5401ZM32.6496 29.4801C31.7696 30.8001 30.6696 31.6801 29.1296 31.9001C28.2496 31.9001 27.1496 32.3401 22.7496 30.5801C19.0096 28.8201 15.9296 25.9601 13.7296 22.6601C12.4096 21.1201 11.7496 19.1401 11.5296 17.1601C11.5296 15.4001 12.1896 13.8601 13.2896 12.7601C13.7296 12.3201 14.1696 12.1001 14.6096 12.1001H15.7096C16.1496 12.1001 16.5896 12.1001 16.8096 12.9801C17.2496 14.0801 18.3496 16.7201 18.3496 16.9401C18.5696 17.1601 18.5696 17.6001 18.3496 17.8201C18.5696 18.2601 18.3496 18.7001 18.1296 18.9201C17.9096 19.1401 17.6896 19.5801 17.4696 19.8001C17.0296 20.0201 16.8096 20.4601 17.0296 20.9001C17.9096 22.2201 19.0096 23.5401 20.1096 24.6401C21.4296 25.7401 22.7496 26.6201 24.2896 27.2801C24.7296 27.5001 25.1696 27.5001 25.3896 27.0601C25.6096 26.6201 26.7096 25.5201 27.1496 25.0801C27.5896 24.6401 27.8096 24.6401 28.2496 24.8601L31.7696 26.6201C32.2096 26.8401 32.6496 27.0601 32.8696 27.2801C33.0896 27.9401 33.0896 28.8201 32.6496 29.4801Z","fill":"#32AD42"}})])
          )
        }
      }
    